export default __webpack_public_path__ + "static/media/pleasewait1.e4215847.PNG";